import React from 'react';
import { Heading } from '..';
import { Icon } from '../icon/icon';
import './page-heading.scss';
export var PageHeading = function (_a) {
    var headingLevel = _a.headingLevel, initials = _a.initials, icon = _a.icon, title = _a.title, subText = _a.subText, progress = _a.progress, mb = _a.mb;
    var classes = 'c-page-heading';
    if (mb) {
        classes += " u-mb-".concat(mb);
    }
    return (React.createElement("div", { className: classes },
        React.createElement("div", { className: "c-page-heading__icon" },
            icon && React.createElement(Icon, { name: icon }),
            initials && React.createElement("span", { className: "c-page-heading__initials" }, initials)),
        React.createElement("div", { className: "c-page-heading__body", style: { width: typeof title === 'string' ? '' : '40vw' } },
            typeof title === 'string' ? (React.createElement("div", { className: "c-page-heading__headingwrap" },
                React.createElement(Heading, { level: "h".concat(headingLevel), title: title }),
                React.createElement("div", null, progress && progress))) : (title),
            subText && React.createElement("p", { className: "c-page-heading__subtext" }, subText))));
};
